import { createReducer } from 'immutable-reducers';
import browserStore from 'store';
import _ from 'lodash';

import {fromJS, Map} from 'immutable';
import * as types from '../constants/actionTypes';
import {LOGIN} from 'modules/auth/constants/actionTypes';

export default createReducer(['profile'], (profile = Map(), action) => {
    switch (action.type) {
        case types.LICENSE_PLATE_SET_PREFERRED:
            return profile.set('licensePlate', action.payload.licensePlate);

        case types.COMPANY_NAME_FETCH_SUCCESS:
            const profileWithCompanyName = profile
                .set('companyName', action.payload.name);

            const cTerminals = action.payload.terminals.filter(terminal => terminal.rights && terminal.rights.length > 0);
            const cRights = cTerminals.reduce((agg, terminal) => [...agg, ...terminal.rights], []);

            const profileWithTerminals =
                !profile.get('terminals').length && cTerminals.length > 0
                    ? profileWithCompanyName.set('terminals', fromJS(cTerminals))
                    : profileWithCompanyName;

            return !profile.get('rights').length && cRights.length > 0
                ? profileWithTerminals.set('rights', fromJS(cRights))
                : profileWithTerminals;

        case types.PROFILE_SET_LOCALE:
            return profile.set('locale', action.payload);

        case LOGIN.SUCCESS:
            const {name, reqComp, reqCompName, terminals, unitKinds, packagingUnity, transCompList, typeDocList, rights, unitStates, prefLP, prefComp} = action.sessionData;
            _.each(packagingUnity, (pu) => {
                pu.code = pu.code.trim();
            });
            _.each(unitStates, (us) => {
                us.code = us.code.trim();
            });
            return profile.merge({
                fullName: name,
                ownerTransId: reqComp,
                requestingCompany: reqCompName,
                licensePlate: prefLP,
                prefComp,
                terminals,
                unitKinds,
                packagingUnity,
                typeDocList,
                transCompList,
                rights,
                unitStates
            });
    }
    return profile;
});
